'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _lodash = require('lodash.merge');
var _lodash2 = _interopRequireDefault(_lodash);
var _reactJplayer = require('react-jplayer');
var _constants = require('../util/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var initialState = exports.initialState = {};
var options = function options(jPlayerOptions, jPlaylistOptions) {
  initialState[jPlayerOptions.id] = (0, _lodash2.default)({}, _constants.defaultStatus, _constants.defaultOptions, jPlaylistOptions);
  if (Array.isArray(jPlaylistOptions.playlist)) {
    var media = jPlaylistOptions.playlist[0];
    return (0, _reactJplayer.initializeOptions)(_extends({}, jPlayerOptions, {
      media: media
    }));
  }
  return (0, _reactJplayer.initializeOptions)(jPlayerOptions);
};
exports.default = options;